module.exports = __webpack_public_path__ + "img/whatsapp.8637d4b4.png";